import { FC } from 'react'

import styled from 'styled-components'

import { PrimarySkeleton } from 'src/Components/Skeletons/PrimarySkeleton'
import { StatsInnerBlock } from 'src/Components/StatsSectionInnerBlock'
import { MetaAdsCampaignDetails } from 'src/Redux/metaAdsDetailsApi'

import {
  getMetaAdsCountiesPerformance,
  getMetaAdsVisualPerformance,
} from '../helpers'

import { PerformanceOverviewTitle } from './PerformanceOverviewTitle'
import { PerformanceChart } from './PerformanceChart'
import { ChartData } from './useChart'
import { usePerformanceOverview } from './usePerformanceOverview'
import { AdVisualPerformanceTable } from './AdVisualPerformanceTable'
import { CountryPerformanceSection } from './CountryPerformanceSection'

const PerformanceOverviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  @media (min-width: 768px) {
    padding: 24px;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
    box-shadow: ${({ theme }) => theme.shadow.card};
  }
`

const StyledSkeleton = styled(PrimarySkeleton)`
  border-radius: 16px;
  height: 120px;
`
export type PerformanceOverviewProps = MetaAdsCampaignDetails & {
  chartData?: ChartData | null
  isChartVisible: boolean
}

export const PerformanceOverview: FC<PerformanceOverviewProps> = (props) => {
  const {
    isLoading,
    lastUpdatedAt,
    impressionsClicksCtrSections,
    conversionsSection,
  } = usePerformanceOverview(props)

  const { isCountryPerformanceVisible } = getMetaAdsCountiesPerformance(
    props.status,
  )

  const { isAdVisualPerformanceVisible } = getMetaAdsVisualPerformance(
    props.status,
  )

  if (isLoading) {
    return (
      <PerformanceOverviewWrapper>
        <StyledSkeleton />
      </PerformanceOverviewWrapper>
    )
  }
  return (
    <PerformanceOverviewWrapper>
      <PerformanceOverviewTitle lastUpdatedAt={lastUpdatedAt} />
      <StatsInnerBlock sections={impressionsClicksCtrSections} />
      <StatsInnerBlock withChangedOrder sections={conversionsSection} />
      {props.isChartVisible && (
        <PerformanceChart
          chartData={props.chartData}
          strategy={props.strategy}
        />
      )}
      {isAdVisualPerformanceVisible && (
        <AdVisualPerformanceTable campaignId={String(props.id)} />
      )}
      {isCountryPerformanceVisible && (
        <CountryPerformanceSection campaignId={String(props.id)} />
      )}
    </PerformanceOverviewWrapper>
  )
}
